export default "__VITE_ASSET__BSDuo66z__"